export default {"src":"/_next/static/media/0x8bec47865ade3b172a928df8f990bc7f2a3b9f79.f7650dac.svg","height":288,"width":288,"blurWidth":0,"blurHeight":0};